import { ReactElement } from "react"

import AmendAcuDeviceForm from "../../../../components/devices/lct/acu/amendAcuDeviceForm"
import NewAcuDeviceAmendmentProvider from "../../../../components/devices/lct/acu/providers/newAcuDeviceAmendmentProvider"

/** Root webpage for amending an Air Conditioning Unit device */
const AmendAcuDevice = (): ReactElement => (
    <NewAcuDeviceAmendmentProvider>
        <AmendAcuDeviceForm />
    </NewAcuDeviceAmendmentProvider>
)

export default AmendAcuDevice
